'use strict';

/* global jQuery */

import { $, $document } from '../../../src/globals';
import initDependencies from '../../../src/modules/dependencies';
import initValidation from '../../../src/modules/validation';
import {
	enhanceSelect,
	enhanceSelects,
} from '../../../src/modules/enhanced-selects.js';
import {
	enhanceDatepicker,
	enhanceDatepickers,
} from '../../../src/modules/enhanced-datepickers.js';
import {
	enhanceAccordion,
	enhanceAccordions,
} from '../../../src/modules/enhanced-accordion.js';
import {
	enhanceUploader,
	enhanceUploaders,
} from '../../../src/modules/enhanced-uploaders';

const initFields = ( $container ) => {
	// init container
	if ( ! $container?.length ) {
		$container = $document;
	}

	// enhance selects
	enhanceSelects( $container );

	// enhance datepicker
	enhanceDatepickers( $container );

	// enhance toggles
	enhanceAccordions( $container );

	// enhance uploader
	enhanceUploaders( $container );

	// init dependencies
	initDependencies( $container );

	// init validation
	initValidation( $container );

	// enhance template fields
	( () => {
		const fieldToProcess = $(
			'.yith-wcaf-enhanced-template',
			$container
		).not( '.enhanced' );

		fieldToProcess.each( function () {
			const $template = $( this ),
				$editor = $template.find( '.editor' );

			$( 'a.toggle_editor', $template )
				.text( function () {
					const $this = $( this );

					$this.text( $this.data( 'view-label' ) );
				} )
				.on( 'click', function () {
					const $this = $( this ),
						editorVisible = $editor.is( ':visible' );

					$this.text(
						$this.data(
							`${ editorVisible ? 'view' : 'hide' }-label`
						)
					);
					$editor.slideToggle();

					return false;
				} );

			$( 'a.delete_template', $template ).on( 'click', function () {
				return window.confirm( $( this ).data( 'confirm' ) );
			} );

			$( 'textarea', $editor ).on( 'change', function () {
				const $this = $( this ),
					name = $this.attr( 'data-name' );

				if ( name ) {
					$this.attr( 'name', name );
				}
			} );

			$template.addClass( 'enhanced' );
		} );
	} )();

	// editable sections
	( () => {
		const $editable = $( '.editable', $container ).not( '.enhanced' );

		$editable
			.one( 'click', function () {
				const $trigger = $( this ),
					$parent = $trigger.parent(),
					$target = $parent.find( '.edit' );

				if ( ! $target ) {
					return;
				}

				const $edited = $parent.find( '.edited' );

				$edited.slideUp();
				$target.slideDown();
				$trigger.removeClass( 'editable' );
			} )
			.addClass( 'enhanced' );
	} )();

	// init custom fields postfix
	( () => {
		const $fields = $( '[data-postfix]', $container ).not( '.enhanced' );

		$fields.each( function () {
			const $field = $( this ),
				$postfix = $( '<span/>', {
					class: 'field-postfix',
					text: $field.data( 'postfix' ),
					style: 'line-height: 2.5; margin-left: 5px;',
				} );

			$field.after( $postfix );
		} );
	} )();

	// remove edit prompt when not needed (double $( fn ) is required to perform code after WC's handler)
	$( () => {
		// when field is contained in one of these items, onbeforeunload will be ignored
		const exceptions = [ '.yith-plugin-fw-list-table-container' ];

		$( 'input, textarea, select', $container ).on( 'change', function () {
			const $closest = $( this ).closest( exceptions.join( ', ' ) );

			if ( ! $closest.length ) {
				return;
			}

			window.onbeforeunload = null;
		} );
	} );
};

// export utilities
export {
	enhanceSelect,
	enhanceDatepicker,
	enhanceAccordion,
	enhanceUploader,
	initFields,
	initDependencies,
	initValidation,
};
